// Central switchboard for which Strategy features the UI shows. Hiding a
// feature here only removes its entry points from the interface - its code,
// Cloud Functions, saved records and credit entitlements are untouched, so
// turning a flag back on restores it exactly as it was.
//
// Unknown keys are hidden by default, so a new, unfinished Strategy never
// appears until it is deliberately listed here.
export const STRATEGY_VISIBILITY = {
  propertyIntelligence: true,
  listingDescription: true,
  // Temporarily hidden while the Strategy section focuses on Property
  // Intelligence (pricing accuracy/cost work is still under review).
  pricing: false,
  compareHomes: false, // Buyer "Compare Homes" table is built on Pricing Strategy results
  // Unfinished ("coming soon") Strategies.
  negotiation: false,
  inspection: false,
};

export function isStrategyVisible(key) {
  return STRATEGY_VISIBILITY[key] === true;
}
